export {ButtonIconModule} from './button-icon.module';
export * from './button-icon.component';
